import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';
import qs from 'qs';

export const inspectionService = {
  getList,
  getChecklist,
  storeOrUpdate,
  destroy,
  email,
};

function getList(facilityId, params = {}) {
  const queryString = qs.stringify({ facility_id: facilityId, ...params }, { addQueryPrefix: true });
  return axios
    .get(`${apiEndpoint.inspections}${queryString}`, { headers: authHeader() })
    .then(res => (res && res.status === 200 && res.data.code === '0000' ? res.data : {}));
}

// Pre-start checklist (sections + items) the form renders from. When a
// facilityId is passed and that asset has a custom template assigned, its
// checklist is returned; otherwise the built-in default is returned.
function getChecklist(facilityId = null) {
  const queryString = facilityId ? qs.stringify({ facility_id: facilityId }, { addQueryPrefix: true }) : '';
  return axios
    .get(`${apiEndpoint.inspectionChecklist}${queryString}`, { headers: authHeader() })
    .then(res => (res && res.status === 200 && res.data.code === '0000' ? res.data : {}));
}

function storeOrUpdate(data, id = null) {
  return (id
    ? axios.put(apiEndpointFunction.inspections(id), data, { headers: authHeader() })
    : axios.post(apiEndpoint.inspections, data, { headers: authHeader() })
  ).then(res => (res && res.status === 200 ? res.data : {}));
}

function destroy(id) {
  return axios
    .delete(apiEndpointFunction.inspections(id), { headers: authHeader() })
    .then(res => (res && res.status === 200 ? res.data : {}));
}

// Re-send an existing inspection report to recipients.
function email(id, recipientEmails) {
  return axios
    .post(apiEndpointFunction.inspectionEmail(id), { recipient_emails: recipientEmails }, { headers: authHeader() })
    .then(res => (res && res.status === 200 ? res.data : {}));
}
